import { ComponentType } from 'react';
import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector, useMMDispatchActions } from './withOwnReduxStore';
import { changeCurrentMediaSource, ChangeCurrentMediaSourcePayload } from '../actions';
import {
  getCurrentMediaSource,
  getMediaSourceTypes,
  getWithMediaSourceSelector,
} from '../selectors';
import { MediaSourceType } from '../types';

export type WithCurrentMediaSourceProps = {
  currentMediaSource?: MediaSourceType;
  changeCurrentMediaSource: (payload: ChangeCurrentMediaSourcePayload) => any;
  mediaSourceTypes?: MediaSourceType[];
  withMediaSourceSelector?: boolean;
};

type OwnProps = Partial<
  Pick<
    WithCurrentMediaSourceProps,
    'currentMediaSource' | 'mediaSourceTypes' | 'withMediaSourceSelector'
  >
> & {
  initialMediaSource?: MediaSourceType;
};

export const useCurrentMediaSource = (): WithCurrentMediaSourceProps => ({
  ...useMMSelector(
    state => ({
      currentMediaSource: getCurrentMediaSource(state),
      mediaSourceTypes: getMediaSourceTypes(state),
      withMediaSourceSelector: getWithMediaSourceSelector(state),
    }),
    shallowEqual
  ),
  ...useMMDispatchActions({
    changeCurrentMediaSource,
  }),
});

export default <TProps>(
  component: ComponentType<TProps & WithCurrentMediaSourceProps>
): ComponentType<TProps & OwnProps> =>
  connectMediaStore(
    (state, ownProps: OwnProps) => ({
      currentMediaSource: getCurrentMediaSource(state) || ownProps.initialMediaSource,
      mediaSourceTypes: getMediaSourceTypes(state) || ownProps.mediaSourceTypes,
      withMediaSourceSelector:
        getWithMediaSourceSelector(state) !== undefined
          ? getWithMediaSourceSelector(state)
          : ownProps.withMediaSourceSelector,
    }),
    { changeCurrentMediaSource }
  )(component as ComponentType<any>); // redux is a bit dumb with generics
